//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './collection-items-bulk-add-menu.html';

import angular from 'angular';

export class CollectionItemsBulkAddMenu {
  public collectionId: string = '';
  public collections: any[];
  public selectedCollectionIds: string[] = [];
  public selectedCollections = [];

  public shouldShowLoadingSpinner: boolean = false;

  constructor(
        private collectionsService,
        private errorNotificationService,
    ) {}

  public addToNewCollection = function(newCollectionName) {
    this.shouldShowLoadingSpinner = true;
    this.createCollectionAsync(newCollectionName)
            .subscribe((collection) => {
              this.selectCollection(collection);
            }, (error) => {
              this.errorNotificationService.showDefaultErrorDialog(error);
            });
  };

  public selectCollection(collection) {
    this.selectedCollectionIds.push(collection.id);
    this.selectedCollections[collection.id] = !this.selectedCollections[collection.id];
  }

  public $onInit() {
    this.collectionsService.getCollections().subscribe((collectionsState) => {
      this.collections = angular.copy(collectionsState.collections);
    });
  }

  private createCollectionAsync = (newCollectionName) => {
    const collectionName = newCollectionName.trim();
    return this.collectionsService.createCollectionWithoutNotification({ name: collectionName })
            .finally(() => {
              this.shouldShowLoadingSpinner = false;
            });
  }
}

angular.module('curalate').component('collectionItemsBulkAddMenu', {
  bindings: {
    selectedCollections: '=',
  },
  template,
  controller: [
    'CollectionsService',
    'ErrorNotificationService',
    CollectionItemsBulkAddMenu,
  ],
});
